import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faPaperPlane, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import s from '../CaseFilePage.module.css';

interface EmailPreviewData {
  templateId: string;
  recipient_email: string;
  subject: string;
  body_html: string;
  footer_html: string;
  unresolved: string[];
}

interface EmailPreviewModalProps {
  emailPreview: EmailPreviewData;
  emailSending: boolean;
  handleSendEmail: () => void;
  onClose: () => void;
}

export default function EmailPreviewModal({
  emailPreview,
  emailSending,
  handleSendEmail,
  onClose,
}: EmailPreviewModalProps) {
  return (
    <ModalOverlay onClose={onClose} title="Email Preview">
      <div className={s.modalForm}>
        <div className={s.emailPreviewField}>
          <strong>To:</strong> {emailPreview.recipient_email || '(not found)'}
        </div>
        <div className={s.emailPreviewField}>
          <strong>Subject:</strong> {emailPreview.subject}
        </div>
        {emailPreview.unresolved.length > 0 && (
          <div className={s.warningBanner}>
            <FontAwesomeIcon icon={faExclamationTriangle} /> Unresolved tokens:{' '}
            {emailPreview.unresolved.map((t) => `{{${t}}}`).join(', ')}
          </div>
        )}
        <div
          className={s.emailPreviewBody}
          dangerouslySetInnerHTML={{ __html: emailPreview.body_html }}
        />
        {emailPreview.footer_html && (
          <div
            className={s.emailPreviewFooter}
            dangerouslySetInnerHTML={{ __html: emailPreview.footer_html }}
          />
        )}
        <div className={s.modalActions}>
          <button className={s.btnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button className={s.btnPrimary} onClick={handleSendEmail} disabled={emailSending}>
            {emailSending ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faPaperPlane} />
            )}
            Send
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
